var manageCookies = {
    methods: {
        _storageKey(name) {
            return "responsly:" + name;
        },
        _setFallbackStorage(name, value, days) {
            try {
                var key = this._storageKey(name);
                var now = Date.now();
                var exp = days ? (now + (Number(days) * 24 * 60 * 60 * 1000)) : null;
                var v = (value === undefined || value === null) ? "" : value;
                localStorage.setItem(key, JSON.stringify({ v: v, exp: exp }));
                return true;
            } catch (e) {
                return false;
            }
        },
        _getFallbackStorage(name) {
            try {
                var key = this._storageKey(name);
                var raw = localStorage.getItem(key);
                if (!raw) return false;
                var parsed = JSON.parse(raw);
                if (parsed && parsed.exp && Date.now() > parsed.exp) {
                    localStorage.removeItem(key);
                    return false;
                }
                if (parsed && Object.prototype.hasOwnProperty.call(parsed, "v")) {
                    return parsed.v;
                }
                return "";
            } catch (e) {
                return false;
            }
        },
        _eraseFallbackStorage(name) {
            try {
                localStorage.removeItem(this._storageKey(name));
            } catch (e) {
                // ignore
            }
        },
        setCookie(name,value,days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            var stringValue = (value || "");
            document.cookie = name + "=" + stringValue  + expires + "; path=/";

            // If cookies are blocked (e.g. 3rd-party context), fall back to localStorage.
            if (this.getCookie(name) === false) {
                this._setFallbackStorage(name, stringValue, days);
            }
        },
        getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return this._getFallbackStorage(name);
        },
        eraseCookie(name) {   
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            this._eraseFallbackStorage(name);
        }
    }
  }
  export default manageCookies